import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../base/dialog/dialog";
import { DialogShell } from "../dialog-shell/DialogShell";
import { DialogShellHeader } from "../dialog-shell/DialogShellHeader";
import { DialogShellBody } from "../dialog-shell/DialogShellBody";
import { DialogShellFooter } from "../dialog-shell/DialogShellFooter";
export function ConfirmDialog({ open, onOpenChange, icon, iconTone, title, description, children, confirmLabel, cancelLabel, onConfirm, onCancel, variant = "primary", isPending = false, isConfirmLoading = false, isConfirmDisabled = false, size = "sm" }) {
    const { t } = useTranslation();
    const resolvedCancel = cancelLabel ?? t("common.cancel");
    const handleCancel = ()=>{
        if (isPending) return;
        if (onCancel) onCancel();
        else onOpenChange(false);
    };
    const handleOpenChange = (next)=>{
        if (!next) handleCancel();
        else onOpenChange(true);
    };
    const confirmAction = {
        label: confirmLabel,
        onClick: onConfirm,
        loading: isPending || isConfirmLoading,
        disabled: isConfirmDisabled
    };
    const cancelAction = {
        label: resolvedCancel,
        onClick: handleCancel,
        disabled: isPending
    };
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ _jsxs(DialogShell, {
            size: size,
            children: [
                /*#__PURE__*/ _jsx(DialogShellHeader, {
                    icon: icon,
                    iconTone: iconTone,
                    title: title,
                    subtitle: description,
                    onClose: handleCancel
                }),
                children && /*#__PURE__*/ _jsx(DialogShellBody, {
                    children: children
                }),
                /*#__PURE__*/ _jsx(DialogShellFooter, {
                    secondary: cancelAction,
                    primary: variant === "primary" ? confirmAction : undefined,
                    danger: variant === "danger" ? confirmAction : undefined
                })
            ]
        })
    });
}

//# sourceMappingURL=confirm-dialog.js.map